import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class BatchService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
	}

	public get(obj) {

		return this.http.post(environment.apiurl + "/Batches/manageBatch?access_token=" + this.globalCfgService.getAccessToken(), obj);
	}


	public details(data) {

		return this.http.post(environment.apiurl + "/Batches/details?access_token=" + this.globalCfgService.getAccessToken(), data);
	}

	public recall(rec) {
		return this.http.post(environment.apiurl + "/Batches/recall?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public cancel(rec) {
		return this.http.post(environment.apiurl + "/Batches/cancel?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public complete(rec) {
		return this.http.post(environment.apiurl + "/Batches/complete?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public batchDistribution(batchNo) {
		var rec = {
			batchNo: batchNo
		};
		return this.http.post(environment.apiurl + "/Batches/distribution?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public add(rec) {
		return this.http.post(environment.apiurl + "/Labels/create?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public createPackage(rec) {
		return this.http.post(environment.apiurl + "/Packages/create?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public createNonAggPackage(rec) {
		return this.http.post(environment.apiurl + "/Packages/addNonAggregation?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public addExtended(rec) {
		return this.http.post(environment.apiurl + "/Batches/addExtended?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public getPackages(rec) {
		return this.http.post(environment.apiurl + "/Packages/managePackage?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public cancelPackage(rec) {
		return this.http.post(environment.apiurl + "/Packages/cancel?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public genExistingBatchLabels(rec) {
		return this.http.post(environment.apiurl + "/Labels/addInstance?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}
	
	public genExistingNonAggBatchLabels(rec) {
		return this.http.post(environment.apiurl + "/Packages/addNonAggregationToExistingBatch?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}
	public getBatchNumber(batchNo){
		var rec = {
			// batchNo: [batchnumber]
		};
		return this.http.get(environment.apiurl + "/Batches/details?batchNo=" + batchNo + "&access_token=" + this.globalCfgService.getAccessToken())
	}

	public updateBatch(data) {
		var rec = {
			batchNo: data.batchNo,
			flags: data.flags,
            fence: data.fence,
			gcp:data.gcp,
			deletedFence: data.deletedFence


		};
		rec.flags.notForSale = data.isNotForSale;
		return this.http.post(environment.apiurl + "/Labels/updateBatch?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public  deletePackageByBatchNo(rec){
		console.log(rec);
		return this.http.post(
			environment.apiurl + 
			"/Packages/deletePackage?access_token=" + this.globalCfgService.getAccessToken(),
			rec
		);
	}

	// filter packageIds list by search id text while linking device to package
	searchPackageIds(filterObj) {
		return this.http.post(
		  environment.apiurl + "/Packages/list?access_token=" +
		  this.globalCfgService.getAccessToken(),
		  filterObj
		);
	}

	//bulk label api
	public genBulkBatchLabels(rec) {
		return this.http.post(environment.apiurl + "/Labels/createBulk?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public getBatchDetails(batchNo) {
		return this.http.get(
			environment.apiurl + 
			"/Batches/details?batchNo=" + batchNo + 
			"&access_token=" + this.globalCfgService.getAccessToken()
		);
	}

	public addLabelToExisitngBulk(batch) {
		return this.http.post(
			environment.apiurl + 
			"/Labels/addLabelToExisitngBulk?access_token=" + this.globalCfgService.getAccessToken(),batch);
	}

	//void one label of a bulk api batch and reissue it in its place
	public replaceBulkLabel(rec) {
		return this.http.post(
			environment.apiurl +
			"/Labels/replaceBulkLabel?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	//one time backfill of the production quantity on an existing batch
	public setProductionQty(rec) {
		return this.http.post(
			environment.apiurl +
			"/Batches/setProductionQty?access_token=" + this.globalCfgService.getAccessToken(), rec);
	}

	public getBulkApiBatchLabel(batchNo){
		return this.http.get(
			environment.apiurl + 
			"/Batches/bulkInstance?batchNo=" + batchNo + 
			"&access_token=" + this.globalCfgService.getAccessToken()
		);
	}
}